import React from 'react'
import WaitingList from "./WaitingList";
import RegisterForm from "./RegisterForm";
import {Col, Container, Row} from "react-bootstrap";
import useFetch from "../hooks/useFetch";


export default function Anmeldung() {
    const { loading, error, data } = useFetch('https://steadfast-festival-dd089030c4.strapiapp.com/api/registration/count', {
        headers: {
            'Authorization': `Bearer ${process.env.REACT_APP_API_KEY}`,
            'Content-Type': 'application/json'
        }

    })

    if (loading) return <p>loading...</p>
    if (error) return <p>Error :(</p>


    let sold_out ="";

    if (data.count < 18) {
        sold_out = false
    } else {
        sold_out = true
    }




    return(
        <div>
            <Container fluid="md">
                <Row>
                    <Col>
                        <div>
                            {sold_out ? <h1>Anmeldung für die Warteliste</h1> : <h1>Anmeldung</h1>}
                            {sold_out ?  <p></p>: <p>Bis jetzt sind {data.count} von 18 Teams angemeldet!</p>}
                            {sold_out ? <WaitingList /> : <RegisterForm />}
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    )

}